import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.83917 0.372626C6.09362 0.605871 6.11081 1.00123 5.87756 1.25568L2.25428 5.20835H14.1668C14.512 5.20835 14.7918 5.48817 14.7918 5.83335C14.7918 6.17853 14.512 6.45835 14.1668 6.45835H0.833509C0.585654 6.45835 0.361218 6.31188 0.261416 6.08501C0.161614 5.85814 0.205306 5.59373 0.372787 5.41102L4.95612 0.411019C5.18937 0.15657 5.58472 0.139381 5.83917 0.372626Z",
      fill: "#6841EA"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.7389 8.91502C14.6391 8.68814 14.4147 8.54168 14.1668 8.54168L0.833508 8.54168C0.488331 8.54168 0.208508 8.8215 0.208508 9.16668C0.208508 9.51186 0.488331 9.79168 0.833508 9.79168L12.7461 9.79168L9.12279 13.7444C8.88954 13.9988 8.90673 14.3942 9.16118 14.6274C9.41563 14.8606 9.81098 14.8435 10.0442 14.589L14.6276 9.58901C14.795 9.4063 14.8387 9.14189 14.7389 8.91502Z",
      fill: "#6841EA"
    }, null, -1)
  ])))
}
export default { render: render }